import uuidv4 from 'uuid/v4';
export function generateUUID(prefix = '') {
    return `${prefix}${uuidv4()}`;
}
